import {
  InitAccountAuthResponse,
  RequestCheckAccountCode,
  RequestConfirmAccount,
  RequestInitAccountAuth,
  RequestLoginAccount,
} from '@/types/auth';
import ApiService from './apiService';

class AuthService extends ApiService {
  public async checkAuth(): Promise<{ isAuthenticated: boolean }> {
    const { status } = await this.fetch('/check', {
      method: 'POST',
      allowedErrorCodes: [401],
    });

    return { isAuthenticated: status === 200 };
  }

  public async initAccountAuth(
    requestData: RequestInitAccountAuth
  ): Promise<InitAccountAuthResponse> {
    const { data } = await this.fetch<InitAccountAuthResponse>('/account/init', {
      method: 'POST',
      body: JSON.stringify(requestData),
    });

    return data!;
  }

  async loginAccount(requestData: RequestLoginAccount): Promise<void> {
    await this.fetch('/account/login', {
      method: 'POST',
      body: JSON.stringify(requestData),
    });
  }

  public async confirmAccount(data: RequestConfirmAccount): Promise<void> {
    await this.fetch('/account/confirm', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  public async checkAccountCode(requestData: RequestCheckAccountCode): Promise<void> {
    await this.fetch('/account/check-code', {
      method: 'POST',
      body: JSON.stringify(requestData),
    });
  }

  public async logout(): Promise<void> {
    await this.fetch('/account/logout', {
      method: 'POST',
    });
  }
}

export const authService = new AuthService();
